// Yeni Görev Ekle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'tasks.addTask';

export const tasksAddTaskGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Yeni görev nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Bir personele bir kerelik (normal) ya da belirli gün ve saatlerde tekrarlanan bir görev atarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Görev bilgileri ve tekrar ayarları'),
    footer: t(`${G}.regions.footer`, 'İptal / Görevi Ekle'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Görev adı ve açıklaması'),
      text: t(`${G}.s1.text`, '"Görev Adı" ve "Görev Açıklaması" zorunludur. Açıklamaya personelin ne yapacağını açık ve kısa yazın.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Personel, şube ve görev grubu'),
      text: t(`${G}.s2.text`, '"Personel Seçin" ve "Görev Grubu Seçin" zorunludur. "Şube Filtresi (Opsiyonel)" ile şube seçerseniz personel listesi yalnız o şubenin personeline iner ve görev o şubeye bağlanır; şube seçiliyken altta kaç personel ve kaç görev grubu bulunduğu yazar.'),
      tips: [
        t(`${G}.s2.tip1`, 'Grup kutusundaki + düğmesi görev grupları penceresini açar; listede uygun grup yoksa buradan yenisini ekleyin.'),
        t(`${G}.s2.tip2`, 'Şube müdürü olarak girdiyseniz şube kendi şubeniz olarak sabittir ve yalnız şubenize ait görev grupları listelenir.'),
        t(`${G}.s2.tip3`, 'Şube değiştirdiğinizde seçili personel o şubede değilse seçim temizlenir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Normal görev: tarih ve tamamlama ayarları'),
      text: t(`${G}.s3.text`, '"Normal Görev" bir kez yapılacak işler içindir. "Başlangıç Tarihi / Saati" ve "Bitiş Tarihi / Saati" isteğe bağlıdır. Başlangıç bugünden önce olamaz; bitiş başlangıçtan önce olamaz, aynı gündeyse bitiş saati başlangıç saatinden sonra olmalıdır.'),
      tips: [
        t(`${G}.s3.tip1`, '"Görev Bitirme Fotoğrafı İste" açıksa personel görevi bitirirken fotoğraf ekler.'),
        t(`${G}.s3.tip2`, '"Görev Reddedilebilsin" açıksa personel görevi reddedebilir.'),
        t(`${G}.s3.tip3`, 'Göreve en çok 5 resim ekleyebilirsiniz; her resim en çok 1MB olmalı ve JPG, JPEG, PNG ya da WEBP olmalıdır. Hatalı resim varsa görev eklenmez; resmi kaldırın veya düzeltin.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Tekrarlı görev: tamamlama türü'),
      text: t(`${G}.s4.text`, '"Tekrarlı Görev"i açınca "Görev Tamamlama Türü" seçilir. QR Kod ile Tamamlama: personel görev yerindeki QR kodu okutarak görevi tamamlar. Buton ile Tamamlama: personel uygulama içinde düğmeye basarak görevi tamamlar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Normal Görev ve Tekrarlı Görev aynı anda seçilemez; birini açınca diğeri kapanır.'),
        t(`${G}.s4.tip2`, 'QR kodu görev oluştuktan sonra Görevler sayfasındaki "QR Yazdır" ile yazdırıp görev yerine asın.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Tekrar tipi, saatler ve tolerans'),
      text: t(`${G}.s5.text`, '"Tekrar Tipi" sekmelerinden birini seçin. Günlük: her gün, "Günlük Tekrar Sayısı" kadar (1–10) saat girersiniz. Haftalık: "Haftanın Günleri"nden günleri seçer, her gün için ayrı tekrar sayısı ve saatler girersiniz. Aylık: ayları, sonra her ay için ayın günlerini ve saatleri seçersiniz; en az bir ay ve her ayda en az bir gün seçilmelidir. Yıllık: yıl ve tarih seçip "Görev Detayları"nı (zorunlu) yazarsınız.'),
      tips: [
        t(`${G}.s5.tip1`, '"Başlama Toleransı (dk)" (5–60, varsayılan 15): görev saatinden bu kadar dakika önce görev "Yaklaşıyor" olur. Saat gelince "Aktif" olur ve bir sonraki saatin tolerans başlangıcına kadar (son saat için 60 dakika) aktif kalır; bu sürede tamamlanmazsa "Kaçırılmış" sayılır.'),
        t(`${G}.s5.tip2`, 'Yıllık görevler yıllık plan olarak kaydedilir; saat ve tolerans girilmez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Görevi ekleyin'),
      text: t(`${G}.s6.text`, '"Görevi Ekle" görev adı, açıklama, personel ve grup dolunca açılır. Kayıttan sonra seçilen personele "Yeni görevin var" bildirimi gönderilir ve pencere kapanır. Eksik ya da hatalı bir alan varsa üstte kırmızı "Hata" kutusunda nedeni yazar.'),
      tips: [
        t(`${G}.s6.tip1`, 'Anketler sayfasından açıldığında pencere tekrarlı ve QR kod ile tamamlanan anket görevi olarak açılır; düğme "Anketi Ekle" olur.'),
      ],
    },
  ],
});
